module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_12-782c01f4adb5fc1eef52442f03838444.png";